
    const toggleButtons = document.querySelectorAll('.tpt-footer-2_mobile-toggle');
    const headingWrappers = document.querySelectorAll('.tpt-footer-2_heading-wrapper');
    
    // Function to toggle menu visibility
    async function toggleMenu(wrapper) {
      const menuId = wrapper.querySelector('.tpt-footer-2_mobile-toggle').getAttribute('aria-controls');
      const menu = document.getElementById(menuId);
      const isExpanded = wrapper.querySelector('.tpt-footer-2_mobile-toggle').getAttribute('aria-expanded') === 'true';
      
      // Close all menus first
      document.querySelectorAll('.tpt-footer-2_menu').forEach(menu => {
        menu.classList.remove('tpt-footer-2_menu-open');
      });
      
      document.querySelectorAll('.tpt-footer-2_mobile-toggle').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      // Toggle current menu
      if (!isExpanded) {
        menu.classList.add('tpt-footer-2_menu-open');
        wrapper.querySelector('.tpt-footer-2_mobile-toggle').setAttribute('aria-expanded', 'true');
      }
    }
    
    // Add click event to both icon and entire heading wrapper
    toggleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent event bubbling
        toggleMenu(this.closest('.tpt-footer-2_heading-wrapper'));
      });
    });
    
    headingWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', function() {
        toggleMenu(this);
      });
      
      // Add keyboard accessibility for Enter key
      wrapper.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          toggleMenu(this);
        }
      });
    });